
import { VreConfiguration } from '@/models/VreConfiguration';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {ajaxPost} from "../../data/ajax";

@Component({})
export default class Heading extends Vue {
    public popoverShow: boolean = false;
    public feedbackText: string = "";
    public feedbackTextState: boolean = true;
    public isAuthenticated: any; //filled by library

    get isInternalUser(): boolean{
        const regex = /x\d{7}@/;
        const email = this.$store.state.authModule.userName;
        if(email.match(regex)){
            return false
        } else {
            return true
        }
    }

    logOff() {
        this.$store.state.authModule.logout();
    }

    onClose() {
        this.popoverShow = false
    }

    created(){
        this.$store.dispatch("getVreConfiguration");
    }

    get maintenanceMessage(): string {
        var config: VreConfiguration = this.$store.state.vreConfiguration;
        var now = new Date();
        if(config && config.maintenance && config.maintenance.message && new Date(config.maintenance.start) <= now && new Date(config.maintenance.end) >= now){
            return config.maintenance.message;
        }
        return null;
    }

    @Watch("feedbackText")
    onFeedbackTextChange(value:string){
        if(value){
            this.feedbackTextState = true;
        } else {
            this.feedbackTextState = false;
        }
    }

    public async onOk() {
        if (!this.feedbackText) {
          this.feedbackTextState = false
        } else {
        
            var feedback = {
                FeedbackText: this.feedbackText,
            }
            const url = process.env.VUE_APP_ROOT_API + "Feedback";
            var token = await this.$store.state.authModule.getapiTokenPopup();
            await ajaxPost(url, token, feedback);
            this.onClose()
        }
    }

    public onShow() {
        // This is called just before the popover is shown
        // Reset our popover form variables
        this.feedbackText = '';
    }
    public onShown() {
        this.focusRef(this.$refs.feedbackText);
        this.feedbackTextState = true;
    }

    public onHidden() {
        // Called just after the popover has finished hiding
        // Bring focus back to the button
        this.focusRef(this.$refs.feedback)
    }
    public focusRef(ref: any) {
        // Some references may be a component, functional component, or plain element
        // This handles that check before focusing, assuming a `focus()` method exists
        // We do this in a double `$nextTick()` to ensure components have
        // updated & popover positioned first
        this.$nextTick(() => {
          this.$nextTick(() => {
            ;(ref.$el || ref).focus()
          })
        })
    }
}
